import { getFirstPossibleRoute } from '@/router/utils/redirectHelpers'
import { type Route } from '@/types/route'

const cancelledLessonsChildrenRoutes = [
  {
    path: '',
    name: 'cancelled-lessons-list' as const,
    component: () =>
      import('@/views/CancelledLessons/CancelledLessonsView.vue'),
    meta: {
      title: 'Cancelled lessons'
    }
  }
] satisfies Route[]

export const cancelledLessonsRoutes = [
  {
    path: 'cancelled-lessons',
    name: 'cancelled-lessons' as const,
    component: () => import('@/views/Layouts/RouterView.vue'),
    meta: {
      title: 'Cancelled lessons',
      icon: 'close-circle',
      permissions: ['lesson_cancellation.view_cancellesson']
    },
    redirect: () => getFirstPossibleRoute(cancelledLessonsChildrenRoutes),
    children: cancelledLessonsChildrenRoutes
  }
] satisfies Route[]
